export default __webpack_public_path__ + "static/media/Neophyte's Belt of Regal Might.36deec09.jpg";